import * as React from 'react'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { CheckIcon, DividerHorizontalIcon } from "@radix-ui/react-icons"

import {mergeClasses} from '../../helpers/styling'

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  /* Tailwind's shadow-sm written out: Bootstrap ships a .shadow-sm with !important that outranks it. */
  <CheckboxPrimitive.Root
    ref={ref}
    className={mergeClasses(
      `peer h-4 w-4 shrink-0
      text-indigo-900
      border !border-indigo-900
      rounded-sm shadow-[0_1px_2px_0_rgb(0_0_0/0.05)]
      focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring
      disabled:cursor-not-allowed disabled:opacity-50
      data-[state=checked]:bg-indigo-900 data-[state=checked]:text-white`,
      className
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={mergeClasses("flex items-center justify-center text-current")}
    >
      {props.checked === "indeterminate" ? (
        <DividerHorizontalIcon className="h-3 w-3" />
      ) : (
        <CheckIcon className="h-3 w-3" />
      )}
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
